// @flow
import React from 'react';

import { loadGroupByCode } from 'groups/lib/GroupPromises';
import BoxBody from 'components/BoxBody';
import Dialog from 'components/Dialog';
import Group from 'entities/Group';
import GroupMessageList from 'groups/components/GroupMessageList';
import LoadingModal from 'components/LoadingModal';
import MessageActions from 'groups/actions/MessageActions';
import MessageStore from 'groups/stores/MessageStore';
import ToastActions from 'actions/ToastActions';

type Props = {
  groupCode: string,
};

type State = {
  group: Group | void,
  groupIsLoading: boolean,
};

export default class GroupMessageListModal extends React.Component<Props, State> {
  state: State = {
    group: undefined,
    groupIsLoading: true,
  };

  async componentDidMount() {
    const group = await loadGroupByCode(this.props.groupCode, true);

    if (!group) {
      this.setState({ groupIsLoading: false });
      ToastActions.showErrorToast('You are no longer in this group.');
      return;
    }

    this.setState({ group, groupIsLoading: false });
    const groupId = group.id;
    if (!MessageStore.isDoneLoadingForGroup(groupId)) {
      MessageActions.loadMessages(groupId);
    }
  }

  render() {
    const { group, groupIsLoading } = this.state;

    if (groupIsLoading) {
      return <LoadingModal />;
    }

    if (!group) {
      return null;
    }

    return (
      <Dialog
        {...this.props}
        textAlign="left"
        className="GroupMessageListModal"
        eventScreenName="GroupMessageListModal">
        <BoxBody>
          <GroupMessageList group={group} />
        </BoxBody>
      </Dialog>
    );
  }
}
